// useFetchAppVersion.js
import { useState, useEffect } from "react";

import { getApiUrl } from "../../utils/apiUrl";

const useFetchAppVersion = () => {
  const [versionData, setVersionData] = useState({
    version: "Cargando...",
    versions: [],
    loading: true,
  });

  useEffect(() => {
    const fetchAppVersion = async () => {
      try {
        const response = await fetch(getApiUrl("api/version/"));
        if (!response.ok) throw new Error("No se pudo cargar el historial de versiones.");
        const data = await response.json();
        setVersionData({
          version: data.version || "Versión no disponible",
          versions: Array.isArray(data.versions) ? data.versions.slice(0, 10) : [],
          loading: false,
        });
      } catch (error) {
        console.error("Error fetching app version:", error);
        setVersionData({ version: "No disponible", versions: [], loading: false });
      }
    };

    fetchAppVersion();
  }, []);

  return versionData;
};

export default useFetchAppVersion;
